<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      token: localStorage.getItem("token") ? localStorage.getItem("token") : ""
      //token: sessionStorage.getItem('token') ? sessionStorage.getItem('token') : ''
    };
  },
  created() {
    if (!this.token) {
      // si no tiene token no ha iniciado sesión
      localStorage.clear();
      this.$router.push("login"); // redireccionar al login
      return null;
    }
  }
};
</script>

<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";
</style>
<!-- IMPORTAR LOS ESTILOS DEL VUE-MULTISELECT -->
<style src="vue-multiselect/dist/vue-multiselect.min.css" ></style>
<style src="pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css" ></style>
<style src="@voerro/vue-tagsinput/dist/style.css" ></style>
<style src="fullcalendar/dist/fullcalendar.css" ></style>
<style src="vue-form-wizard/dist/vue-form-wizard.min.css" ></style>
<!--<style src="vue-good-table/dist/vue-good-table.css" ></style> 
 <style src="vue2-daterange-picker/dist/vue2-daterange-picker.css" ></style> -->